import { publishQueries } from '@/entities/sets/publish';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { ModalLayout } from '@/shared/ui';
import { showToast } from '@/shared/utils/toast';
import { useEffect, useState } from 'react';
import { PublishPasswordEditCompletePopup } from './publish-password-edit-complete-popup';
import { usePersistStore } from '@/shared/lib/store';
import { useQueryClient } from '@tanstack/react-query';

export const PublishStntResetPasswordPopup = ({ data }: { data: DATA.PublishNickListType }) => {
    const queryClient = useQueryClient();
    const [password, setPassword] = useState('****');
    const [passwordEditState, setPasswordEditState] = useState(false);
    const { showModal, closeModal } = useModalStore();
    const { sUserId } = usePersistStore();

    const { mutate } = publishQueries.list.postIntegPubResetPwd();

    useEffect(() => {
        if (data && data.initAt === 'Y') {
            setPasswordEditState(true);
        }
    }, [data]);

    const onEditPassword = () => {
        mutate(
            {
                wrterId: sUserId,
                publishId: data?.publishId,
                stdtUserId: data?.stdtUserId,
                initAt: 'Y',
            },
            {
                onSuccess: (res) => {
                    if (res && res?.resultData?.resultOk) {
                        setPasswordEditState(true);
                        passwordEditComplete();
                        setPassword('1234');
                        closeModal('publish-reset-password');
                        queryClient.invalidateQueries({
                            queryKey: ['publish-list', 'nick-list'],
                        });
                    } else {
                        setPasswordEditState(false);
                        showToast('비밀번호 변경 실패', 2000);
                    }
                },
            }
        );
    };

    const passwordEditComplete = () => {
        showModal({
            isCustom: true,
            id: 'password-edit-complete',
            initContents: () => <PublishPasswordEditCompletePopup />,
        });
    };

    return (
        <ModalLayout title="학생 관리" wrapClassNm="box-width1" contClassNm="cont-pd1">
            <div className="form-row">
                <div className="form-label label-width1">닉네임</div>
                <div className="form-td">
                    <input
                        readOnly
                        type="text"
                        className="input-txt"
                        style={{ width: '100%' }}
                        value={data?.nickNm}
                    />
                </div>
            </div>
            <div className="form-row">
                <div className="form-label label-width1">비밀번호</div>
                <div className="form-td type-flex flex-gap1">
                    <input
                        type={passwordEditState ? 'text' : 'password'}
                        className="input-txt"
                        style={{ width: '127px' }}
                        value={password}
                        readOnly
                    />
                    <button
                        className="btn btn-default lightblue btn-style1"
                        disabled={passwordEditState}
                        onClick={!passwordEditState ? onEditPassword : undefined}
                    >
                        비밀번호 초기화 {passwordEditState && '완료'}
                    </button>
                </div>
            </div>
            {/* <div className="form-row">
                <div className="form-label label-width1">비밀번호</div>
                <div className="form-td type-flex flex-gap1">
                    <input
                        type="password"
                        className="input-txt"
                        style={{ width: '127px' }}
                        value="김비상"
                    />
                    <button className="btn btn-default lightblue btn-style1" disabled>
                        비밀번호 초기화 완료
                    </button>
                </div>
            </div> */}
            <div
                className="btn-wrap btn-width1 // con-mt3"
                onClick={() => closeModal('publish-reset-password')}
            >
                <button className="btn btn-default medium blue">확인</button>
            </div>
        </ModalLayout>
    );
};
